/** Meta connector + legacy Comuni `template_*` field shapes for WhatsApp preview. */
export type WhatsappPreviewFormData = {
  // Meta
  element_name?: string;
  language_code?: string;
  category?: string;
  vertical?: string;
  header?: string;
  content?: string;
  footer?: string;
  // Legacy Comuni / older connector
  template_name?: string;
  template_language?: string;
  template_category?: string;
  template_header_text?: string;
  template_body_text?: string;
  template_footer_text?: string;
  // Shared
  parameter_format?: 'POSITIONAL' | 'NAMED';
  header_examples?: string[];
  body_examples?: string[];
  waba_id?: string;
  [key: string]: unknown;
};

export type ResolvedWhatsappPreviewFields = {
  name: string;
  language: string;
  category: string;
  header: string;
  headerImageUrl: string;
  body: string;
  footer: string;
  parameterFormat: 'POSITIONAL' | 'NAMED' | undefined;
  headerExamples: string[] | undefined;
  bodyExamples: string[] | undefined;
};

const pickString = (formData: WhatsappPreviewFormData, keys: string[]): string => {
  for (const key of keys) {
    const value = formData[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
};

/** Prefer Meta keys, then legacy `template_*` keys. */
export const resolveWhatsappPreviewFields = (formData: WhatsappPreviewFormData): ResolvedWhatsappPreviewFields => ({
  name: pickString(formData, ['element_name', 'template_name']),
  language: pickString(formData, ['language_code', 'template_language']),
  category: pickString(formData, ['category', 'template_category']),
  header: pickString(formData, ['header', 'template_header_text']),
  headerImageUrl: pickString(formData, ['header_image_url']),
  body: pickString(formData, ['content', 'template_body_text']),
  footer: pickString(formData, ['footer', 'template_footer_text']),
  parameterFormat: formData.parameter_format,
  headerExamples: formData.header_examples,
  bodyExamples: formData.body_examples,
});
